// root head as a still picture (D-059): the assistant's icon wherever root is shown small (chips, menu
// items, events, cards, buttons) and the stand-in while a 3D root loads or when WebGL is off. Rendered
// from the shipped head GLB by tools/mascot/render_head_icon.py, so it is the same face as the 3D
// root head. Decorative: the control around it carries the accessible name.
import { cx } from "@ady/ui";
import rootHeadUrl from "./root-head.png?url";

export function RootHead({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <img
      src={rootHeadUrl}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={cx("flex-none select-none object-contain", className)}
    />
  );
}
